interface IProps {
  image: string;
  businessName?: string;
  tagline?: string;
  buttonText?: string;
}

export const HeroCenter = ({
  image,
  businessName,
  tagline,
  buttonText,
}: IProps) => {
  const scrollToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      left: 0,
      behavior: "smooth",
    });
  };

  const cBusinessName = (
    <h1 className={"flex font-medium lg:text-4xl text-primary-500"}>
      {businessName}
    </h1>
  );

  const cTagline = (
    <h2
      className={"flex w-full font-bold text-xl lg:text-6xl text-primary-600"}
    >
      {tagline}
    </h2>
  );

  const cButton = (
    <button
      className={
        "self-start lg:self-center mt-8 py-2 px-6 md:py-4 md:px-8 rounded-lg lg:text-2xl text-white bg-primary-300 hover:bg-primary-100 transition-colors duration-300 ease-in-out"
      }
      onClick={scrollToBottom}
    >
      {buttonText}
    </button>
  );

  return (
    <section>
      <div className={"flex relative w-full h-[70vh] text-pretty"}>
        <img
          className={"h-full w-full object-cover overflow-hidden"}
          src={image}
          alt={"hero"}
          loading={"eager"}
          rel={"preload"}
        />
        <div
          className={
            "flex absolute h-full min-w-min max-w-full items-center justify-center bg-gradient-to-r from-[#DDDDDD] lg:from-10% to-transparent"
          }
        >
          <div className={"flex flex-col w-3/4 lg:w-[60%] gap-8"}>
            {businessName && cBusinessName}
            {tagline && cTagline}
            {buttonText && cButton}
          </div>
        </div>
      </div>
    </section>
  );
};
